import { render } from "./ContactList.vue?vue&type=template&id=17e23bff&scoped=true&ts=true&lang=pug"
import script from "./ContactList.vue?vue&type=script&lang=ts"
export * from "./ContactList.vue?vue&type=script&lang=ts"

import "./ContactList.vue?vue&type=style&index=0&id=17e23bff&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e23bff"]])

export default __exports__